export default __webpack_public_path__ + "static/media/pickup.671ac0cf.svg";